<div class="lvi-content list-view-item-hover py-3">
    <div class="avatar">
        <i class="material-icons-outlined align-middle">code</i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a class="label" (click)="extraOptions.onSelect(data)">{{ data.nom }}</a>
        </div>
        <ul class="lvi-attrs">
            <li>
                <strong [translate]="'admin.bibliotheque.notifications.balise.portee'"></strong>
                <span translate>{{ 'admin.bibliotheque.notifications.balise.portees.' + data.idPortee }}</span>
            </li>
            <li *ngIf="!!data.description">
                <strong [translate]="'admin.bibliotheque.notifications.balise.description'"></strong>
                <span>{{ getTruncatedDescription(data.description) }}</span>
            </li>
        </ul>
    </div>
    <div class="lvi-actions" *ngIf="!extraOptions.isReadOnly">
        <button mat-icon-button (click)="onDelete()" [matTooltip]="'global.actions.supprimer' | translate">
            <i class="nio icon-suppression"></i>
        </button>
    </div>
</div>